var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 235,
    height: 50,
    viewBox: "0 0 235.00001 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("colorProfile", {
    id: "color-profile2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    clipRule: "evenodd",
    id: "path50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9,-9 H 851 V 605 H -9 Z",
    transform: "translate(2.5000001e-5)",
    clipRule: "evenodd",
    id: "path86"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "matrix(0.20729329,0,0,0.16660674,-236.42696,-24.054957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 462.9759,335.3513 c -1.3346,-0.3441 -2.1252,-0.7197 -2.9157,-0.7265 -7.9501,-0.0555 -15.9089,-0.2381 -23.8439,0.0865 -1.6694,0.0683 -3.7282,1.7232 -4.813,3.2227 -7.8058,10.7909 -15.404,21.7341 -23.0808,32.6188 -0.6168,0.8728 -1.3346,1.6761 -2.2799,2.8517 -4.1446,-3.8702 -8.8441,-6.5427 -8.2253,-13.4014 0.6256,-6.9165 0.0238,-13.9345 0.159,-20.9021 0.0627,-3.2513 -1.038,-4.6845 -4.4475,-4.5706 -5.3765,0.1809 -10.7629,0.0797 -16.1453,0.0111 -2.613,-0.0323 -3.7557,1.0658 -3.7514,3.7256 0.0385,31.1901 0.0428,62.38 0.019,93.5708 -0.002,2.9675 1.3002,4.1295 4.244,4.0589 5.2574,-0.125 10.5217,-0.142 15.7774,0.0102 3.1884,0.0927 4.3489,-1.2308 4.3123,-4.3401 -0.1029,-8.6831 -0.064,-17.3679 -0.017,-26.0527 0.008,-1.6353 0.3135,-3.2681 0.5803,-5.8487 1.8328,1.4593 2.9931,2.2286 3.973,3.1824 11.0375,10.745 22.0839,21.4844 33.0398,32.3161 2.181,2.1575 3.9943,2.6751 6.592,0.6146 4.0164,-3.1867 8.2944,-6.0446 12.4171,-9.0978 1.5795,-1.1687 2.2374,-2.4905 0.4904,-4.2112 -4.6905,-4.6241 -9.2846,-9.3466 -13.9601,-13.9861 -5.0261,-4.9847 -9.9935,-10.0338 -15.2019,-14.8212 -2.486,-2.2839 -2.2779,-4.1386 -0.4555,-6.6011 12.073,-16.3063 24.0823,-32.6616 36.0938,-49.0152 0.483,-0.658 0.7818,-1.4486 1.4392,-2.6947",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 318.4994,364.4906 c -0.0859,0.0171 -0.1693,0.0341 -0.2551,0.0514 -0.0559,1.2186 -0.0409,2.4454 -0.1783,3.6549 -0.9241,8.021 -6.6056,14.0715 -13.6038,14.5296 -7.9843,0.5201 -13.9167,-3.8208 -15.4962,-12.3721 -0.7477,-4.0632 -0.5626,-8.5819 0.3955,-12.6108 1.7535,-7.3701 6.5469,-10.7302 13.6893,-10.821 6.9577,-0.0875 11.9228,3.4637 14.1446,10.4298 0.7285,2.2865 0.885,4.7532 1.304,7.1382 z m -54.7478,0.0213 c -0.7112,22.9799 16.5231,37.7634 37.9715,38.2275 11.2394,0.2423 21.8024,-2.1555 30.064,-10.2045 11.8715,-11.5662 13.4294,-25.9217 8.994,-41.0289 -4.153,-14.1446 -14.7027,-21.6326 -28.8133,-23.7515 -6.16,-0.9258 -12.7375,-0.9216 -18.8722,0.1378 -18.9275,3.268 -29.3185,16.639 -29.344,36.6196",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 507.8188,360.3271 c 0.2639,0.2279 0.5264,0.4581 0.7906,0.6857 -1.1687,1.1495 -2.215,3.0816 -3.5368,3.2916 -2.9758,0.4751 -6.2827,0.7311 -9.0844,-0.1327 -2.2473,-0.6944 -4.4453,-2.8493 -5.7544,-4.9317 -1.315,-2.0905 -0.2576,-4.4994 1.8003,-6.139 3.7605,-2.997 7.3834,-1.2886 10.995,0.3272 2.9546,1.3235 5.436,3.0101 4.7897,6.8989 z m 24.5526,0.254 c 0.002,-6.9701 0.0176,-13.9431 -0.002,-20.9132 -0.015,-5.191 -0.0796,-5.2344 -5.4229,-5.2387 -1.3456,-0.002 -2.7032,0.1182 -4.0335,-0.0238 -2.9846,-0.3177 -5.2191,0.6596 -6.7314,3.3262 -1.6761,2.9591 -3.5325,2.9888 -6.1305,0.7353 -10.5026,-9.1148 -27.9547,-7.6433 -36.2934,3.4206 -7.2499,9.6216 -7.3051,28.1712 7.3248,34.4755 6.0165,2.5914 12.185,3.1133 18.5349,3.1391 0.7344,0.004 1.5017,-0.142 2.1954,0.0261 1.8521,0.4507 3.6703,1.0329 5.5029,1.5641 -1.4355,1.9874 -2.5033,5.101 -4.3852,5.7155 -3.3242,1.0848 -7.2023,1.1282 -10.7459,0.7132 -3.7128,-0.4343 -7.3309,-1.8309 -10.934,-2.9801 -1.8675,-0.5975 -3.015,-0.3611 -3.6678,1.6328 -1.5174,4.6301 -3.2216,9.2027 -4.5961,13.8742 -0.2517,0.8509 0.4295,2.7244 1.1256,2.9996 14.3941,5.6744 29.0631,9.3421 43.9124,1.9808 9.6372,-4.7789 13.9666,-13.3557 14.3039,-23.9062 0.2168,-6.8412 0.0408,-13.6931 0.0428,-20.541",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 546.0914,370.8757 c 0.002,10.5199 0.0907,21.0416 -0.0494,31.5598 -0.045,3.3899 1.0183,4.7183 4.5876,4.875 5.5327,0.2449 9.7745,-1.1154 12.1247,-6.5426 1.2379,-2.8537 2.8111,-2.9693 5.7095,-1.3431 5.0732,2.8491 10.5752,4.9589 15.9857,7.168 3.062,1.2506 5.1078,0.2406 5.8405,-3.2766 0.8697,-4.1856 1.9789,-8.3262 3.1045,-12.452 0.7693,-2.823 -1.061,-3.0787 -3.0424,-3.82 -5.5565,-2.0843 -11.0401,-4.377 -16.4693,-6.7705 -2.755,-1.2138 -3.5864,-3.5904 -3.5541,-6.6116 0.1245,-11.3751 0.0536,-22.7525 0.0471,-34.1294 -0.002,-4.6029 -0.3589,-4.9547 -5.0494,-4.9657 -4.5246,-0.006 -9.0527,0 -13.5774,0.0153 -5.5695,0.017 -5.6443,0.0814 -5.6534,5.8337 -0.017,10.1526 -0.006,20.3068 -0.004,30.4597",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 375.0265,294.4752 c 9.0694,4.9141 17.6726,7.0027 26.7814,7.0027 116.6941,-0.002 233.3866,0.009 350.0816,-0.0471 31.7594,-0.015 59.1916,21.437 67.1868,52.7911 7.4174,29.097 -6.5254,60.6052 -33.6782,75.3284 -24.512,13.2911 -48.9104,10.7087 -73.0057,-1.4034 -5.3606,-2.6946 -10.5781,-5.6809 -15.8593,-8.5326 -0.3288,0.4385 -0.6576,0.8748 -0.9862,1.3133 6.5897,4.9677 12.7245,10.741 19.8451,14.7699 44.9135,25.4186 101.1359,0.2211 111.2649,-50.3716 9.9358,-49.6406 -27.1031,-89.6965 -71.1405,-90.7473 -30.1997,-0.7197 -60.4293,-0.2726 -90.646,-0.3177 -62.89,-0.0927 -125.7815,-0.1956 -188.6735,-0.2322 -32.6704,-0.0218 -65.3431,0.0879 -98.0163,0.1505 -0.6937,0.002 -1.3879,0.1268 -3.1541,0.296",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 646.7165,370.8544 h -0.0213 c 0,3.9022 0.1783,7.8194 -0.0884,11.704 -0.1055,1.5452 -0.7906,3.5113 -1.9126,4.4456 -4.5504,3.7927 -12.5974,3.2317 -16.8066,-1.027 -6.2138,-6.285 -6.1755,-14.0806 -4.5382,-21.9101 2.0908,-10.0109 9.663,-13.7432 19.3166,-10.2515 2.9158,1.0533 4.0717,2.8063 4.0547,5.6962 -0.0195,3.7797 -0.004,7.5611 -0.004,11.3428 z m -39.5059,-45.7341 c 7.9393,-1.6439 15.2062,-3.479 22.585,-4.5596 4.9269,-0.7222 9.7849,0.438 13.5649,4.1338 1.016,0.9947 2.0733,2.228 2.4404,3.5388 0.4666,1.6633 0.2491,3.5175 0.3291,5.2903 -1.599,0.0215 -3.2423,0.3027 -4.7874,0.0238 -21.0416,-3.8098 -41.8085,7.086 -43.4829,32.1871 -0.5026,7.5481 -0.2705,14.987 2.6109,21.996 5.6231,13.6721 16.5102,19.98 30.8333,21.1405 7.185,0.5822 13.8807,-0.8206 19.9117,-4.8691 2.3553,-1.5792 4.2568,-2.0154 6.0489,0.9114 0.5626,0.9178 2.1912,1.4864 3.4032,1.6353 2.1703,0.2642 4.394,0.0365 6.5946,0.1071 2.6146,0.0859 3.7664,-1.0828 3.7598,-3.7233 -0.047,-24.4584 0.1333,-48.9172 -0.1522,-73.3691 -0.1267,-10.9262 -8.0923,-21.1428 -18.3223,-24.7374 -1.3447,-0.4725 -2.8706,-0.5976 -4.3123,-0.6044 -11.3726,-0.051 -22.7585,-0.3347 -34.1099,0.1293 -3.8248,0.157 -7.6408,2.1013 -11.2958,3.6227 -0.8229,0.3418 -1.6441,2.5826 -1.2979,3.5195 1.8028,4.8948 3.9815,9.6477 5.6789,13.6273",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 119.7941,427.9771 c -2.9089,-3.0444 -6.1883,-5.8204 -8.655,-9.19 -5.3561,-7.3162 -12.1504,-9.8433 -21.1581,-8.9685 -8.8481,0.8617 -17.8231,0.3697 -26.7401,0.5976 -2.211,0.0558 -3.124,-0.6489 -3.0917,-2.8962 0.0774,-5.2557 0.0816,-10.5157 -0.0043,-15.7714 -0.0388,-2.2694 1.0032,-3.0149 3.1088,-2.9954 4.523,0.0383 9.0527,-0.1485 13.5689,0.0128 2.8193,0.1012 4.8112,-0.6574 6.4698,-3.111 2.8754,-4.2461 6.1149,-8.2446 9.1599,-12.3789 0.6168,-0.8382 1.0462,-1.8156 1.8887,-3.3067 -1.9942,-0.1717 -3.3866,-0.3908 -4.7767,-0.3954 -8.4379,-0.0363 -16.8777,-0.1394 -25.3111,0.0323 -3.2596,0.0647 -4.2934,-1.1151 -4.1406,-4.28 0.2211,-4.5145 0.2645,-9.0592 -0.0107,-13.5672 -0.2152,-3.5342 1.2764,-4.3874 4.4906,-4.3486 10.7586,0.1309 21.532,-0.2234 32.2773,0.1658 6.2033,0.2228 10.6557,-1.468 13.7602,-7.0934 2.0971,-3.7987 5.004,-7.1529 8.0385,-11.3896 -2.0716,-0.3096 -3.4059,-0.6792 -4.7424,-0.6817 -24.3337,-0.0366 -48.6675,0.0263 -72.9992,-0.0902 -3.4849,-0.017 -4.6562,1.0446 -4.6429,4.6004 0.1157,30.4469 0.0621,60.8958 0.0729,91.3422 0.002,4.8628 0.0538,4.9079 4.9269,4.9121 24.8233,0.0131 49.6451,0.0131 74.4684,0.003 1.184,0 2.3681,-0.1333 3.5498,-0.2047 0.1656,-0.3308 0.3288,-0.6639 0.4921,-0.9969",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 197.9473,364.4226 c 0,-10.5131 -0.0839,-21.0288 0.0493,-31.5402 0.0428,-3.3067 -1.1135,-4.7917 -4.4651,-4.4476 -1.0891,0.1114 -2.2218,0.1505 -3.2962,-0.0176 -4.2817,-0.6638 -7.3868,0.9502 -9.267,4.7787 -1.2957,2.6342 -2.7847,2.0605 -5.0128,1.0726 -5.6619,-2.516 -11.3284,-5.3203 -17.2927,-6.8009 -19.4667,-4.8299 -32.7371,5.1894 -33.3366,25.2383 -0.4487,15.0239 -0.0711,30.071 -0.1443,45.1097 -0.0127,2.7544 1.1968,3.6034 3.7928,3.5515 5.6211,-0.1139 11.2484,-0.148 16.8695,0.0153 2.6921,0.0774 3.2616,-1.053 3.2446,-3.4852 -0.0885,-13.081 -0.0562,-26.1626 -0.0392,-39.2439 0.0153,-11.2782 4.5723,-14.6084 15.2793,-11.2094 0.5823,0.1846 1.173,0.3478 1.7425,0.5695 7.5637,2.9268 7.6518,3.0577 7.6538,11.1107 0.002,12.3486 0.0729,24.6968 -0.045,37.0434 -0.0324,3.2361 0.9042,4.6608 4.3852,4.4992 5.2446,-0.2447 10.5179,-0.2254 15.7646,-0.008 3.3202,0.1377 4.2117,-1.2657 4.1794,-4.3274 -0.1114,-10.6339 -0.0431,-21.272 -0.0431,-31.9082 h -0.019 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "m 230.6089,391.3387 c 4.811,2.454 9.2568,4.9975 13.9193,7.0433 9.4198,4.1337 10.2818,3.6289 12.7527,-6.2139 0.6248,-2.4905 1.1407,-5.0088 1.8156,-7.484 0.5653,-2.071 -0.008,-2.7482 -2.2048,-3.5022 -5.9451,-2.0412 -11.7124,-4.6114 -17.4903,-7.1121 -2.5118,-1.0874 -3.3194,-3.2185 -3.2913,-5.98 0.1072,-10.6398 0.0468,-21.2822 0.034,-31.9246 -0.008,-8.2724 0.5587,-7.6451 -7.8361,-7.6536 -4.1601,-0.004 -8.3194,0.0732 -12.4775,-0.002 -2.4798,-0.0451 -3.4676,0.9521 -3.4617,3.4852 0.0581,21.6501 0.0624,43.302 0.003,64.9547 -0.008,2.6663 0.9513,3.9039 3.6459,3.6372 0.1207,-0.0128 0.2475,-0.017 0.3657,0.004 5.9346,1.1024 10.1568,-0.9408 12.4792,-6.6605 0.3935,-0.9667 1.1821,-1.7725 1.7467,-2.5912",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 753.3573,310.2316 c 9.4286,4.585 20.4083,9.0263 30.4599,15.0233 14.7376,8.7919 25.5005,21.549 32.2753,37.4445 0.5842,1.3692 0.4555,3.0405 0.6554,4.5706 -1.2765,-0.6919 -2.6561,-1.2486 -3.8183,-2.0996 -21.4095,-15.6983 -46.1021,-22.7177 -71.7573,-27.1976 -3.1953,-0.559 -6.4052,-1.0377 -9.828,-0.7455 5.1137,1.7164 10.2359,3.4121 15.3413,5.1548 22.8127,7.7888 45.3376,16.1836 64.8236,30.9365 1.6177,1.2243 3.1867,2.5095 4.7619,3.7922 -1.1415,8.53 -3.9305,16.5381 -8.0405,23.7064 -0.4963,-0.288 -1.2274,-0.5202 -2.226,-0.726 -34.0393,-7.0435 -65.9929,-19.2268 -94.669,-39.194 -5.6724,-3.9493 -10.9026,-8.5391 -16.2893,-12.8923 -1.0117,-0.8186 -1.8003,-1.9125 -2.6895,-2.8791 34.4668,19.2671 69.6036,35.8594 110.2544,37.4726 -1.3294,-1.1492 -2.5758,-2.4132 -4.0002,-3.4288 -20.4942,-14.6002 -43.5884,-23.5993 -67.4473,-30.7395 -12.1765,-3.6417 -24.6325,-6.3428 -36.9462,-9.523 -0.3458,-0.0901 -0.6664,-0.1502 -0.9715,-0.193 2.776,-5.423 6.2808,-10.4103 10.3975,-14.8303 0.1744,0.0451 0.3501,0.0986 0.5261,0.1182 16.7191,1.7875 33.4877,3.1714 50.1483,5.3739 6.8783,0.9088 13.5281,3.5342 21.3194,5.6636 -9.4802,-7.8508 -19.8862,-11.2782 -30.5005,-13.6718 -10.7479,-2.4236 -21.6655,-4.4243 -32.6149,-5.4487 10.8873,-8.1048 24.3703,-12.9076 38.9551,-12.9076 26.4527,0 49.2693,15.7969 59.5571,38.4443 -12.0067,-17.0433 -39.1334,-31.9935 -57.6768,-31.2241",
    style: {
      fill: "#374797",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 763.4307,426.6366 c -37.0406,1.3617 -61.4134,-19.9341 -71.1164,-30.426 -2.7057,-5.7325 -4.6006,-11.9166 -5.5397,-18.4096 7.946,10.4746 33.8224,40.2681 76.6561,48.8356",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 790.5577,420.7972 c -54.3098,-3.9838 -84.0736,-42.0973 -84.0736,-42.0973 0,0 51.1798,29.194 98.0337,24.5103 -71.1516,-8.8163 -107.9816,-43.1906 -116.6366,-49.9637 1.2163,-5.1007 3.0297,-9.9698 5.3629,-14.531 0.3078,0.0408 0.6276,0.1009 0.9734,0.1911 12.3142,3.1824 24.7705,5.8807 36.9445,9.5229 23.8612,7.1399 46.9548,16.1411 67.447,30.7387 1.4264,1.0165 2.6728,2.2821 4.0011,3.4316 -40.6488,-1.6135 -75.7865,-18.2058 -110.2553,-37.4729 0.8918,0.9649 1.6798,2.0608 2.6921,2.8769 5.3867,4.3537 10.6169,8.943 16.2893,12.8948 28.6764,19.9652 60.6291,32.148 94.6664,39.1912 1.0015,0.2064 1.7317,0.4411 2.228,0.7265 -4.4756,7.8061 -10.5004,14.6175 -17.6729,19.9809",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m 767.1651,431.8756 c -5.0281,1.2444 -10.279,1.915 -15.6872,1.915 -3.2403,0 -6.4264,-0.2449 -9.5426,-0.7029 2.7786,0.3588 5.6189,0.5482 8.5156,0.5524 5.8762,0.006 11.4415,-0.5907 16.7142,-1.7645",
    style: {
      fill: "#91181d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 740.9577,432.9332 c 0.2797,0.0405 0.5524,0.0986 0.8339,0.1349 -0.2795,-0.0405 -0.5567,-0.0899 -0.8339,-0.1349",
    style: {
      fill: "#91181d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m 706.485,378.701 c 0,0 29.7635,38.1127 84.0733,42.0968 -6.88,5.1437 -14.8065,8.9557 -23.3926,11.0783 -5.2728,1.1713 -10.8397,1.7708 -16.7142,1.764 -2.8968,-0.004 -5.7368,-0.193 -8.5156,-0.5519 -0.0493,-0.008 -0.0961,-0.0127 -0.146,-0.0193 -0.2789,-0.0365 -0.5519,-0.0943 -0.8314,-0.1352 -21.56,-3.5025 -39.6108,-17.5787 -48.6439,-36.7211 9.7033,10.4899 34.0758,31.7857 71.1167,30.4231 -42.8335,-8.5666 -68.7101,-38.3581 -76.6562,-48.8347 -0.4445,-3.071 -0.6851,-6.2079 -0.6851,-9.3988 0,-5.2192 0.6315,-10.2878 1.7895,-15.1566 8.6573,6.7745 45.4856,41.1494 116.6389,49.9635 C 757.6648,407.895 706.485,378.701 706.485,378.701",
    style: {
      fill: "#91181d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 816.2697,377.1102 c -1.5724,-1.2827 -3.1434,-2.5673 -4.7611,-3.7922 -19.4842,-14.7529 -42.0109,-23.1477 -64.8238,-30.9367 -5.1052,-1.7425 -10.2251,-3.4376 -15.3411,-5.1546 3.4248,-0.2899 6.6325,0.1871 9.828,0.7456 25.6552,4.4798 50.3478,11.4998 71.7573,27.1981 1.1622,0.851 2.5416,1.4071 3.82,2.0988 -0.2015,-1.5299 -0.0731,-3.2012 -0.6554,-4.5698 -6.7765,-15.8961 -17.5376,-28.6526 -32.2752,-37.4451 -10.0517,-5.9969 -21.0308,-10.4383 -30.4617,-15.0236 18.5451,-0.7693 45.6727,14.1812 57.6768,31.225 3.7366,8.2225 5.8337,17.3413 5.8337,26.9459 0,2.9546 -0.2149,5.8575 -0.5975,8.7086",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 775.6379,335.0395 c -7.793,-2.1294 -14.4437,-4.7548 -21.3214,-5.6636 -16.6606,-2.2025 -33.429,-3.5864 -50.1454,-5.3739 -0.1786,-0.017 -0.3527,-0.0731 -0.5287,-0.1182 2.7133,-2.9138 5.6806,-5.5846 8.8784,-7.9654 10.9491,1.0276 21.867,3.0252 32.6146,5.4493 10.6169,2.3936 21.0228,5.8204 30.5025,13.6718",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m 741.7911,433.0689 c 0.0473,0.007 0.0966,0.0108 0.1442,0.0193 -0.0476,-0.006 -0.0969,-0.0127 -0.1442,-0.0193",
    style: {
      fill: "#131726",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1142.5197,793.7008)",
    clipPath: "url(#clipPath86)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoa);
export default __webpack_public_path__ + "static/media/LOGOA.e33579ee20c5fb6cdbe069b34601dd43.svg";
export { ForwardRef as ReactComponent };